export interface ApiResponse<T> {
  success?: boolean;
  message?: string;
  response: T;
}

export interface PaginatedResponse<T> {
  items: T[];
  totalPages: number;
}

export const getErrorMessage = (
  error: unknown,
  fallback = "Ocorreu um erro ao processar a solicitação."
): string => (error instanceof Error ? error.message : fallback);
